/**
 * @generated SignedSource<<b6165975c094ade087c33f6a0db63ae4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PieceOriginalImagesBody_piece$data = {
  readonly sheets: ReadonlyArray<{
    readonly id: string;
    readonly download_url: string;
    readonly " $fragmentSpreads": FragmentRefs<"PieceOriginalImage_sheet">;
  }>;
  readonly " $fragmentType": "PieceOriginalImagesBody_piece";
};
export type PieceOriginalImagesBody_piece$key = {
  readonly " $data"?: PieceOriginalImagesBody_piece$data;
  readonly " $fragmentSpreads": FragmentRefs<"PieceOriginalImagesBody_piece">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PieceOriginalImagesBody_piece",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MusicSheet",
      "kind": "LinkedField",
      "name": "sheets",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "download_url",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PieceOriginalImage_sheet"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MusicPiece",
  "abstractKey": null
};

(node as any).hash = "ef5004a91a69cb206babc20b48d55c50";

export default node;
